import { apiUrl, getAuthToken } from "./api";

export interface PinStatus {
    enabled: boolean;
    locked: boolean;
    unlocked_until: string | null;
    pin_locked_until: string | null;
    unpaid: { count: number; total: number };
}

export interface PinResult extends Partial<PinStatus> {
    message?: string;
    settled?: { count: number; total: number };
}

export const PIN_RE = /^\d{6}$/;

// Gọi API mã bảo mật bằng token đăng nhập. Lỗi trả về dưới dạng { ok: false, message }.
export async function pinRequest(path: string, body?: object): Promise<{ ok: boolean; status: number; data: PinResult }> {
    try {
        const res = await fetch(apiUrl(`/security/pin${path}`), {
            method: body ? "POST" : "GET",
            headers: { "Content-Type": "application/json", Authorization: `Bearer ${getAuthToken()}` },
            body: body ? JSON.stringify(body) : undefined,
        });
        const data = await res.json().catch(() => ({}));
        if (res.status === 401) {
            return { ok: false, status: 401, data: { message: "Phiên đăng nhập đã hết hạn. Vui lòng đăng xuất và đăng nhập lại." } };
        }
        return { ok: res.ok, status: res.status, data };
    } catch {
        return { ok: false, status: 0, data: { message: "Không thể kết nối đến server" } };
    }
}

export const onlyDigits = (value: string) => value.replace(/\D/g, "").slice(0, 6);
